import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full mb-10" }
const _hoisted_2 = {
  key: 1,
  class: "h-[60vh]"
}
const _hoisted_3 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loader = _resolveComponent("Loader")!
  const _component_EmptyData = _resolveComponent("EmptyData")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_Loader, {
          key: 0,
          loader: _ctx.loading,
          loaderSize: "h-[80vh]"
        }, null, 8, ["loader"]))
      : (_ctx.error)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_EmptyData, {
              data: _ctx.error,
              title: `${_ctx.$t('studentCourse.errors.pdf.title')}`,
              label: `${_ctx.$t('studentCourse.errors.pdf.description')}`,
              image: 'waiting_object.svg',
              imgSize: "h-40",
              msgSize: "text-xl lg:w-5/12"
            }, null, 8, ["data", "title", "label", "image"])
          ]))
        : (_openBlock(), _createElementBlock("iframe", {
            key: 2,
            src: _ctx.validatedUrl,
            class: "w-full h-[80vh]",
            onLoad: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleIframeLoad && _ctx.handleIframeLoad(...args)))
          }, null, 40, _hoisted_3))
  ]))
}